import React from 'react';
import config from 'react-global-configuration';

import { Block } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Button, Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import ParagraphsRenderer from '../../../../components/ParagraphsRenderer';
import Video from '../../../../components/Video';
import { BLOCK_NEWSLETTER_SUBSCRIBE_BLOCK_ID, ZENCHEF_CLASSES, DOMAIN_AMSTERDAMUNDERGROUND } from '../../../../config/constants';
import type { NodeVideoPage } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodeVideoPageFullProps extends React.ComponentPropsWithoutRef<'article'> {
  entity: ImmutableEntity<NodeVideoPage>;
}

const NodeVideoPageFull: React.FC<NodeVideoPageFullProps> = ({ entity }) => {
  const node = entity.toJS();
  const title = node.title[0].value;
  const body = node.body[0]?.processed;
  const videoItem = node.field_media_item[0];
  const source = videoItem.bundle === 'remote_video' ? videoItem.embed : videoItem.source;
  const poster = node.field_image[0].styles.crop_4_3 || '';
  const linkAlias = node.field_link[0]?.alias;
  const linkUri = node.field_link[0]?.uri;
  const linkUrl = linkAlias || linkUri;
  const linkTitle = node.field_link[0]?.title;
  const linkClasses = node.field_link[0]?.options?.attributes?.class;
  const paragraphs = node.field_paragraphs;
  const currentDomainIsAmsterdamUnderground = config.get('CURRENT_DOMAIN') === DOMAIN_AMSTERDAMUNDERGROUND;

  return (
    <article className="NodeVideoPageFull">
      {/* Start of content */}
      <Container className="NodeVideoPageFull__container">
        <div className="row">
          <div className="col-12">
            <div className="NodeVideoPageFull__container--video">
              {source && (
                <Video
                  source={source}
                  poster={poster}
                  className="NodeVideoPageFull__video"
                  playIcon={<span className="NodeVideoPageFull__playButton ParagraphVideo__video__poster icon icon-play icon-variant-2" />}
                />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="NodeVideoPageFull__title">
              <h1>{title}</h1>
            </div>
            <div className="NodeVideoPageFull__body">
              {body && (
                <WysiwygField
                  property="schema:text"
                  html={body}
                />
              )}

              {(linkUrl && linkTitle) && (
                <Button
                  className="NodeVideoPageFull__cta"
                  href={linkUrl.match(/<nolink>/) === null ? linkUrl : ''}
                  {...(linkClasses?.[0] && linkClasses[0].includes(ZENCHEF_CLASSES.OPEN) && {
                    'data-zc-action': 'open',
                  })}
                >
                  {linkTitle}
                  {!currentDomainIsAmsterdamUnderground && <i className="icon icon-arrow-right icon-variant-2" />}
                </Button>
              )}
            </div>
          </div>
        </div>
      </Container>
      {/* End of content */}

      {/* Start of paragraphs */}
      {paragraphs.length > 0 && (
        <ParagraphsRenderer
          className="node--page--paragraphs-wrapper"
          paragraphs={paragraphs}
        />
      )}
      {/* End of paragraphs */}

      {!currentDomainIsAmsterdamUnderground && (
        <Block id={BLOCK_NEWSLETTER_SUBSCRIBE_BLOCK_ID} />
      )}
    </article>
  );
};

export default NodeVideoPageFull;
